import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import useFormik from 'hooks/useFormik';
import authService from 'store/auth/service';
import FormInputRow from 'components/Form/InputRow';
import FormInput from 'components/Form/Input';
import ActionRow from 'components/ActionRow';
import Loader from 'components/Loaders/Loader';
import { CompanyLogo } from 'components/CompanyLogo';
import { ContentBox } from 'components/ContentBox';
import { CompanyContext } from 'index';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';

import { validationSchema } from './validationSchema';
import styles from './styles.module.scss';
import { LoginPage } from '../../paths';

export const ResetPasswordByEmailPage = () => {
  const navigate = useNavigate();
  const company = useContext(CompanyContext);

  const [resetPassword, { isLoading, status: resetPasswordStatus }] =
    authService.endpoints.resetPassword.useMutation();

  const sentToEmail = (data: { email: string }) => {
    resetPassword(data);
  };

  const { getFieldProps, getFieldErrorProp, handleSubmit } = useFormik({
    initialValues: {
      email: '',
    },
    validationSchema,
    onSubmit: (value) => {
      sentToEmail({ email: value.email });
    },
  });

  useEffect(() => {
    if (resetPasswordStatus === 'fulfilled') {
      navigate(LoginPage);
    }
  }, [resetPasswordStatus]);

  return (
    <div className={styles.root}>
      <ContentBox className={styles.content}>
        <CompanyLogo src={company.logo} responsive={true} />
        <div className={styles.description}>Please enter your email</div>
        <form onSubmit={handleSubmit} className={styles.form}>
          <FormInputRow
            className={styles.inputRow}
            required
            {...getFieldErrorProp('email')}
          >
            <FormInput
              {...getFieldProps('email')}
              autoComplete="email"
              placeholder={'Email'}
            />
          </FormInputRow>
          <ActionRow style="space-between">
            <ButtonWithArrowIcon type="submit" disabled={isLoading}>
              Submit
            </ButtonWithArrowIcon>
          </ActionRow>
          {isLoading && <Loader />}
        </form>
      </ContentBox>
    </div>
  );
};
